
import config from '../config';

class Store {

    async getItems(chefId, handleItems) {
        const res = await fetch(
            `${config.apiEndpoint}/ms/chefmenu?chefId=${chefId}`,
            {
                method: "get",
                headers: { "Content-Type": "application/json" },
            }
        )
        console.log(res)
        var data = await res.json();
        handleItems(data);
    }

}

const generalFlows = new Store();
export default generalFlows;
